import React, { useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
type Status = 'idle' | 'error' | 'success';
type SubscribeFormProps = {
  id?: string;
  buttonLabel?: string;
  successText?: string;
  align?: 'center' | 'left';
  className?: string;
};
export function SubscribeForm({
  id = 'updates-email',
  buttonLabel = 'Get updates',
  successText = 'You’re subscribed. We’ll email you when new features ship.',
  align = 'center',
  className = 'mt-9'
}: SubscribeFormProps) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const centered = align === 'center';
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim()) ? 'success' : 'error');
  };
  if (status === 'success') {
    return <p role="status" className={`${centered ? 'mx-auto' : ''} ${className} inline-flex items-center gap-2 rounded-[10px] border border-canvas-line bg-white px-5 py-3.5 text-[15px] font-medium text-ink`} data-id="element-1722" data-mp="a0n4zdpiipt6">
        <CheckCircle2Icon className="h-5 w-5 shrink-0 text-[#1B7A3D]" aria-hidden="true" data-id="element-1723" data-mp="1zyil579ovebr" />
        {successText}
      </p>;
  }
  return <div className={`${centered ? 'mx-auto' : ''} ${className} w-full max-w-[420px]`} data-id="element-1724" data-mp="29pwfz1qp3pyk">
      <form onSubmit={onSubmit} noValidate className={`flex w-full flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-[10px] sm:border sm:bg-white sm:p-1.5 sm:focus-within:border-ink/40 ${status === 'error' ? 'sm:border-[#C0362C]' : 'sm:border-ink/15'}`} data-id="element-1725" data-mp="2drrrt0695lql">
        <label htmlFor={id} className="sr-only" data-id="element-1726" data-mp="1q25r28a8eygh">
          Email address
        </label>
        <input id={id} type="email" inputMode="email" autoComplete="email" value={email} onChange={e => {
        setEmail(e.target.value);
        if (status === 'error') setStatus('idle');
      }} placeholder="Enter your email" aria-invalid={status === 'error'} aria-describedby={status === 'error' ? `${id}-error` : undefined} className={`h-12 min-w-0 flex-1 rounded-[10px] border bg-white px-4 text-[16px] text-ink outline-none placeholder:text-ink-muted sm:h-auto sm:rounded-none sm:border-0 sm:bg-transparent sm:px-3 sm:py-2 ${status === 'error' ? 'border-[#C0362C]' : 'border-ink/15'}`} data-id="element-1727" data-mp="1v21mhj4v5hkf" />
        <button type="submit" className="h-12 shrink-0 rounded-[7px] bg-brand px-5 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover sm:h-auto sm:py-2.5" data-id="element-1728" data-mp="nohcfr78zebn">
          {buttonLabel}
        </button>
      </form>
      {status === 'error' && <p id={`${id}-error`} className={`mt-2 text-left text-[13px] font-medium text-[#C0362C] ${centered ? 'sm:text-center' : ''}`} data-id="element-1729" data-mp="sky42vdnoath">
          Enter a valid email address, like name@business.rw
        </p>}
    </div>;
}